<template>
  <div id="head_page" class="head_page">
    <el-row >
      <el-col :xs="8" :sm="8" :lg="8" >
        <div class="logo2" @click="goHome">
        </div>
      </el-col>
      <el-col class="hidden-xs-only" :xs="8" :sm="8" :lg="8">
        <el-row>
          <div class="p5" style="margin-top: 20px">
            {{ $t('message.Bus_Audience') }}
          </div>
        </el-row>
        <el-row>
          <div class="p6">
            {{ $t('message.Measurement') }}
          </div>
        </el-row>
      </el-col>

      <el-col :xs="16" :sm="8" :lg="8" class="Previous_Data">
        <el-row id="selectLanguage">
          <el-col :xs="18" :sm="18" :lg="18" :offset="6" style="text-align: right;">
            <p class="p3">
              <a @click="switchLang_cli('cn')">中文</a>
              |
              <a @click="switchLang_cli('en')">English</a>
            </p>
          </el-col>
        </el-row>
        <el-row id="userInfo">
          <el-col :xs="18" :sm="18" :lg="18" :offset="6" style="text-align: right;"><strong>{{ $t('message.Welcome') }}, {{user_name}}</strong></el-col>
          <el-col :xs="18" :sm="18" :lg="18" :offset="6" style="text-align: right;">
              <p class="psmall" style="font-weight:500;color:#000088" @click = "signOut">
                <i class="el-icon-switch-button"></i> {{ $t('message.Sign_Out') }}
              </p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  var data_value = 0;
  var head_page_type = false;
  var previous_data_offset = "2";
  var language_offset = "2";
  export default {
    name: 'head_page',
    props: ['head_page_type', 'city_name'],
    data() {
      return {
        user_name: 'default_user',
        data_value: data_value,
        previous_data_offset: previous_data_offset,
        language_offset: language_offset,
      }
    },

    created() {
      let lang = JSON.parse(sessionStorage.getItem('lang'))
      if ((lang == null) || (lang == 'en')) {

        this.switchLang('en');
      } else {

        this.switchLang('cn');
      }
    },
    methods: {
      goHome: function() {
        this.$router.push({
          path: '/choose_city'
        });
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        let user = JSON.parse(sessionStorage.getItem("User"));
        let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
        sessionStorage.clear();
        sessionStorage.setItem("lang", JSON.stringify(lang));
        sessionStorage.setItem("User", JSON.stringify(user));
        sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      },
      
      signOut: function(){
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        sessionStorage.clear()
        sessionStorage.setItem("lang", JSON.stringify(lang))
        this.$router.push({
          path: '/'
        });
      },

      update_user_name: function() {
        if (JSON.parse(sessionStorage.getItem('User')) != null) {
          this.user_name = JSON.parse(sessionStorage.getItem('User')).split('.')[0].toUpperCase();
        }
      },

      switchLang: function(event) {
        sessionStorage.setItem('lang', JSON.stringify(event))
        if (this.lang != event) {
          this.lang = event
          this.p4LanSelected = !this.p4LanSelected
          this.$i18n.locale = this.lang
        }
        sessionStorage.setItem('lang', JSON.stringify(this.lang))
        return this.lang
      },
      switchLang_cli: function(event) {
        sessionStorage.setItem('lang', JSON.stringify(event))
        if (this.lang != event) {
          this.lang = event
          this.p4LanSelected = !this.p4LanSelected
          this.$i18n.locale = this.lang
        }
        sessionStorage.setItem('lang', JSON.stringify(this.lang))
        //this.$router.go(0)
      },

      get_user_name: function() {
        return this.user_name;
      },

    }

  }
</script>
<style lang="scss" scoped>
  .Previous_Data{
    padding:0;
  }
  .p3{
    @media (max-width:767px) {
    }
    
    @media (min-width:768px) {
      height:30px;
    }
    cursor: pointer;
  }

  #head_page{
    width: 100%;
    padding: 0px;
    .logo2{
      background-image: url(../assets/bam_logo.png);
      background-position: left top;
      background-repeat: no-repeat;
      background-size:contain;
      z-index:100;
      @media (max-width:767px) {
        height:75px;
        width:150px;
      }
      
      @media (min-width:768px) {
        height:100px;
        width:200px;
      }
    }
    .p4{
      height:100%;
      text-align:left;
      padding-top: 36px;
      font-size:30px;
      color:#2d6461;
    }	
    .psmall {
      font-size:10px;
    }
      .p5{
          font-size: 22px;
          color:#254A6E;
          padding:0px;
          font-weight: 600;
      }
      .p6{
          font-size:25px;
          color: #9A9A9A;
          font-weight: 400;
          //margin-bottom: 12%;
      }
  }

  #selectLanguage {
    @media (max-width:767px) {
      margin-top:5px;
      font-size: 12px;
    }
    
    @media (min-width:768px) {
      height:40px;
      margin-top:20px;
    }
  }

  #userInfo {
    @media (max-width:767px) {
      height:20px;
      font-size: 14px;
    }
    
    @media (min-width:768px) {
      height:20px;
      position:relative;
      top:-15px;
    }
  }
</style>
